import script from "./ModalBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalBox.vue?vue&type=script&setup=true&lang=ts"

import "./ModalBox.vue?vue&type=style&index=0&id=3e696883&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e696883"]])

export default __exports__